export default __webpack_public_path__ + "static/media/language-hu.776371db.svg";